import { useFetch } from '../../use-fetch/use-fetch';
import { AnyObject, ApiResponse, ResponseModel } from '../../../common/interfaces';
import { useQuery } from 'react-query';
import { ConditionOperator, ReactQueryKeys } from '../../../common/enums';
import { crmDataTypes, RequestStatuses } from '../../../constants';
import { crmEntityRequestConfig } from '../../../request-config/crm-entity/crm-entity.request-config';
import { getResponseFormData } from '../../../utils/get-response-data';

const modifyResponse = ({ data }: ApiResponse<AnyObject[]>) => {
  if (data.level === RequestStatuses.Success) {
    return getResponseFormData(data, [{ name: 'entityes', type: 'array' }]) as AnyObject[];
  }

  return [];
};

const useCarModelsByCarBrand = (carBrandId: string) => {
  const { fetch } = useFetch<ResponseModel>({
    isShowLoading: false,
    isShowErrorSnackbar: false,
    ...crmEntityRequestConfig.getEntityByFieldQuery({
      entityName: 'uds_carmodel',
      columns: ['uds_carmodelid', 'uds_name'],
      conditions: [
        {
          attributeTypeCode: crmDataTypes.Lookup,
          attributeName: 'uds_carbrandid',
          conditionOperator: ConditionOperator.Equal,
          value: [
            {
              id: carBrandId,
              logicalName: '',
              name: ''
            }
          ]
        },
        {
          attributeTypeCode: crmDataTypes.State,
          attributeName: 'statecode',
          conditionOperator: ConditionOperator.Equal,
          value: [{ value: '0' }]
        }
      ],
      order: { predicate: 'uds_name', reverse: false }
    })
  });

  const { data: carModels } = useQuery<ApiResponse<AnyObject[]>, unknown, AnyObject[]>(
    [ReactQueryKeys.GetCarModelsByCarBrand, carBrandId],
    fetch,
    {
      select: modifyResponse,
      enabled: !!carBrandId
    }
  );

  return {
    carModels
  };
};

export default useCarModelsByCarBrand;
